import ResourceService from './resource.service'

class LicenseTypeService extends ResourceService {
  static get resource() {
    return 'license-type'
  }
}

export default LicenseTypeService
